module.exports = __webpack_public_path__ + "img/卫生间_image.b12f8deb.png";